import React from 'react';
import ReceptionistContainer from '@src/containers/Receptionist';
import PermissionGate from '@src/components/PermissionGate';
import { PERMISSIONS } from '@src/constants';

const Receptionist = () => (
  <PermissionGate
    requiredPermissions={[
      PERMISSIONS.VIEW_CUSTOMER,
      PERMISSIONS.MANAGE_CUSTOMER,
    ]}
  >
    <ReceptionistContainer />
  </PermissionGate>
);

export default Receptionist;
